"use strict";

var React           = require("react");
var Router          = require("react-router");
var Link = Router.Link;

var headerLogo      = require("../../../images/header_logo.jpg");

var Footer = React.createClass({
    render: function () {
        return (
            <div className="row frontpage-footer">
                <div className="col-sm-2 col-sm-offset-5">
                    <img src={headerLogo}></img>
                </div>
                <div className="col-sm-6 col-sm-offset-3">
                    <div className="col-sm-1">
                        Skilmálar
                    </div>
                    <div className="col-sm-1">
                        Blogg
                    </div>
                    <div className="col-sm-1">
                        Api
                    </div>
                    <div className="col-sm-1">
                        Aðstoð
                    </div>
                    <div className="col-sm-2">
                        Hafa samband
                    </div>
                    <div className="col-sm-2">
                        Búnaðarbankinn
                    </div>
                    <div className="col-sm-1">
                        Verðskrá
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = Footer;



// WEBPACK FOOTER //
// ./app/scripts/ui/Frontpage/Footer.react.js